'use strict'

import Axios from 'axios';
import configuration from "../../configuration";

const url = configuration.apiHost;

export default class CityService {

  static async getAll() {
    try {
      let officces = await Axios.get(url + "city");
      return officces.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()

  static async save(city) {
    try {
      let citySaved = await Axios.post(url + "city", city);
      return citySaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(city) {
    try {
      let cityUpdated = await Axios.put(url + "city", city);
      return cityUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(city) {
    try {
      await Axios.delete(url + "city", {
        data: city
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/CityService.js